import API from '../config/api.js'

export const TrustSheetService = {    
  
    getClubTrustSheet(clubId) {
        return API.get(`api/trust-sheets/${clubId}/promises`);
    },   

    update(data) {
        return API.post(`api/trust-sheets/promise`, data);
    }

}



